// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js. ex: import DropdownController from "./dropdown_controller";
import { application } from "./application";
import { registerNiiwinControllers } from "@niiwin/core";

// Import and register all Niiwin Stimulus controllers (first)
registerNiiwinControllers(application);

// Load this app's controllers (second, in case they override Niiwin controllers)
// application.register("dropdown", DropdownController)

import AlertController from "./alert_controller";
import BasicSelectController from "./basic_select_controller";
import FlashController from "./flash_controller";
import FormsContentSectionsController from "./forms/content_sections_controller";
import FormsDateRangeController from "./forms/date_range_controller";
import FormsDirtyTrackingController from "./forms/dirty_tracking_controller";
import FormsFilterrificFormController from "./forms/filterrific_form_controller";
import FormsSlugController from "./forms/slug_controller";
import FormsNestedSortableController from "./forms/nested_sortable_controller";
import FormsMenuItemTypeController from "./forms/menu_item_type_controller";
import FormsStatusPublishedAtController from "./forms/status_published_at_controller";
import PopoverController from "./popover_controller";
import ShareController from "./share_controller";
import TrixController from "./trix_controller";
import InlineEditOpenController from "./inline_edit_open_controller";
import InlineEditCloseController from "./inline_edit_close_controller";
import VideoEmbedController from "./video_embed_controller";
import AudioPlayerController from "./audio_player_controller";
import AutoClickController from "./auto_click_controller";
import ObfuscateValueController from "./obfuscate_value_controller";
import RemoteSelectController from "./remote_select_controller";

application.register("alert", AlertController);
application.register("basic-select", BasicSelectController);
application.register("flash", FlashController);
application.register("forms--content-sections", FormsContentSectionsController);
application.register("forms--date-range", FormsDateRangeController);
application.register("forms--dirty-tracking", FormsDirtyTrackingController);
application.register("forms--filterrific-form", FormsFilterrificFormController);
application.register("forms--slug", FormsSlugController);
application.register("forms--nested-sortable", FormsNestedSortableController);
application.register("forms--menu-item-type", FormsMenuItemTypeController);
application.register(
  "forms--status-published-at",
  FormsStatusPublishedAtController,
);
application.register("popover", PopoverController);
application.register("share", ShareController);
application.register("trix", TrixController);
application.register("inline-edit-open", InlineEditOpenController);
application.register("inline-edit-close", InlineEditCloseController);
application.register("video-embed", VideoEmbedController);
application.register("audio-player", AudioPlayerController);
application.register("auto-click", AutoClickController);
application.register("obfuscate-value", ObfuscateValueController);
application.register("remote-select", RemoteSelectController);
